import { record, string, boolean, number, object } from 'zod';

const BackendPersistedDataSchema = record(
  string(),
  // This makes it so we don't require backend deployments for new boolean/number fields in the backend persisted schemas
  boolean().or(number())
).and(
  object({
    hasFeedAccess: boolean().default(false),
    hasDismissedNewPostFeatureBanner: boolean().default(false),
    hasDismissedSetupProfile: boolean().default(false),
    version: number().int().min(1)
  })
);
const DefaultBackendPersistedDataSchema = {
  hasFeedAccess: false,
  hasDismissedNewPostFeatureBanner: false,
  hasDismissedSetupProfile: false,
  version: 2
};

export { BackendPersistedDataSchema, DefaultBackendPersistedDataSchema };
